const supportsFlags = {
  linearEasing: void 0
};
export {
  supportsFlags
};
